import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Columns from "@/pages/lanmu/page";
import ColumnDetail from "@/pages/lanmu/detail";
import ArticleDetail from "@/pages/wenzhang/page";
import About from "@/pages/guanyu/page";
import Contact from "@/pages/lianxi/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/lanmu",
    element: <Columns />,
  },
  {
    path: "/lanmu/:slug",
    element: <ColumnDetail />,
  },
  {
    path: "/wenzhang/:slug",
    element: <ArticleDetail />,
  },
  {
    path: "/guanyu",
    element: <About />,
  },
  {
    path: "/lianxi",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;